module.exports = __webpack_public_path__ + "img/yingli.85b21f11.jpg";